<template>
  <div class="flex flex-vertical-center">
    <!-- Address -->
    <div class="flex-grow">
      <p class="contact_name">{{ contactName }}</p>
    </div>

    <!-- Date -->
    <div v-if="!isMobile" class="header_section">
      <div class="created_at">
        <p class="created_at--label">Created</p>
        <p class="created_at--date">{{ createdDate }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "ContactHeader",
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        full_name: ' ',
        created_at: null,
      };
    },
    contactName() {
      return this.contact.full_name !== ' ' ? this.contact.full_name : 'Unknown Contact';
    },
    createdDate() {
      return dates.formatAsDateTime(this.contact.created_at);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.contact_name {
  font-size: 18px;
  font-weight: bold;
}

.header_section {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.created_at {
  margin-left: 10px;

  &--label {
    margin-bottom: 4px;
    font-size: 8px;
    color: $text-muted;
  }

  &--date {
    color: $text-muted;
  }
}
</style>
